<script setup lang="ts">
  defineProps({
    panicModeText: {
      type: String,
      default: 'panic-mode'
    }
  });
</script>

<template>
  <div class="chat-screen chat-panic-screen">
    <div class="chat-screen__wrapper">
      <p>{{ panicModeText }}</p>
    </div>
  </div>
</template>
